const CONTAINER_SELECTOR = '.js-expandingBlocks';

function initExpandingBlocks() {
    const containers = Array.from(document.querySelectorAll(CONTAINER_SELECTOR));
    if (containers.length === 0) return;
    // Only apply on screens wider than 992px
    if (window.innerWidth <= 992) return;

    containers.forEach((container) => {
        const directChildren = Array.from(container.children);
        let remeasureAttempts = 0;
        const MAX_REMEASURE_ATTEMPTS = 10;

        function setActive(childEl) {
            directChildren.forEach((el) => el.classList.remove('-active'));
            childEl.classList.add('-active');

            const colorRaw = childEl.getAttribute('data-color') || childEl.dataset.color || '';
            if (container._expandingBlocksColorClass) {
                container.classList.remove(container._expandingBlocksColorClass);
            }
            if (colorRaw) {
                const colorClass = `-${colorRaw.trim()}`;
                container.classList.add(colorClass);
                container._expandingBlocksColorClass = colorClass;
            } else {
                container._expandingBlocksColorClass = '';
            }
        }

        // Set first child active on load if present
        if (directChildren.length > 0) {
            setActive(directChildren[0]);
        }

        directChildren.forEach((childEl) => {
            childEl.addEventListener('mouseover', () => {
                if (window.innerWidth <= 992) return;
                setActive(childEl);
            });
        });

        // Track a pending timer for delayed height measurement
        let pendingHeightTimer = null;

        // Validate that for all non-active items: <p> height exceeds container height
        function validateTextHeights() {
            const items = Array.from(container.querySelectorAll(':scope > *'));
            for (const item of items) {
                if (item.classList.contains('-active')) continue;
                const textEl = item.querySelector('.js-expandingBlocksText');
                if (!textEl) continue;
                const pEl = textEl.querySelector('p');
                if (!pEl) continue;
                const containerHeight = Math.ceil(textEl.clientHeight);
                const paragraphHeight = Math.ceil(pEl.scrollHeight);
                if (!(paragraphHeight > containerHeight)) {
                    return false;
                }
            }
            return true;
        }

        // Measure and apply dimensions on load and resize
        function applyDimensions() {
            // Bail (and reset inline styles) on small screens
            if (window.innerWidth <= 992) {
                const textEls = Array.from(container.querySelectorAll('.js-expandingBlocksText'));
                textEls.forEach((el) => {
                    el.style.height = '';
                    el.style.width = '';
                });
                container.classList.remove('-measuring');
                return;
            }
            if (directChildren.length === 0) return;

            const textEls = Array.from(container.querySelectorAll('.js-expandingBlocksText'));
            if (textEls.length === 0) return;

            // Mark measuring state to disable transitions via CSS
            container.classList.add('-measuring');

            // Reset inline height before re-measuring (keep width intact)
            textEls.forEach((el) => {
                el.style.height = '';
            });

            // Preserve currently active block
            const previouslyActive = directChildren.find((el) => el.classList.contains('-active')) || null;

            // Ensure first block is active for measurement
            setActive(directChildren[0]);

            // Width: measure first block's text width and apply to all text elements
            const firstTextEl = directChildren[0].querySelector('.js-expandingBlocksText');
            if (firstTextEl) {
                const measuredWidth = Math.ceil(firstTextEl.getBoundingClientRect().width);
                if (measuredWidth > 0) {
                    textEls.forEach((el) => {
                        el.style.width = `${measuredWidth}px`;
                    });
                }
                // Force reflow to ensure width adjustments are applied before height measurement
                void firstTextEl.offsetWidth;
            }

            // Measure heights immediately using rAF cycles (no long timers needed)
            if (pendingHeightTimer) clearTimeout(pendingHeightTimer);
            // Ensure measurement is done with the first block active
            setActive(directChildren[0]);
            // Measure on the next frame after style recalculation
            requestAnimationFrame(() => {
                // Use a second RAF to allow layout to fully settle after width assignment
                requestAnimationFrame(() => {
                    let maxTextHeight = 0;
                    textEls.forEach((el) => {
                        const pEl = el.querySelector('p');
                        const h = Math.ceil((pEl ? pEl.scrollHeight : el.scrollHeight));
                        if (h > maxTextHeight) maxTextHeight = h;
                    });
                    if (maxTextHeight > 0) {
                        textEls.forEach((el) => {
                            el.style.height = `${maxTextHeight}px`;
                        });
                    }
                    // After calculations, remove widths to let layout flex naturally
                    textEls.forEach((el) => {
                        el.style.width = '';
                    });

                    // Restore previously active block after measurements
                    if (previouslyActive && previouslyActive !== directChildren[0]) {
                        setActive(previouslyActive);
                    }

                    // If invalid, try again up to MAX_REMEASURE_ATTEMPTS
                    const isValid = validateTextHeights();
                    if (!isValid && remeasureAttempts < MAX_REMEASURE_ATTEMPTS) {
                        remeasureAttempts++;
                        setTimeout(() => applyDimensions(), 100);
                    } else {
                        remeasureAttempts = 0;
                        // End measuring state to re-enable transitions
                        container.classList.remove('-measuring');
                    }
                });
            });
        }

        // Debounce helper
        function debounce(fn, delay) {
            let t;
            return function debounced() {
                clearTimeout(t);
                t = setTimeout(() => fn(), delay);
            };
        }

        const debouncedApply = debounce(applyDimensions, 150);

        // Initial apply after DOM is ready
        applyDimensions();

        // Re-apply after full load (fonts/images)
        window.addEventListener('load', applyDimensions, { once: true });

        // Re-apply on resize
        window.addEventListener('resize', debouncedApply);

        // Expose for potential external triggers
        container._applyExpandingBlocksDimensions = applyDimensions;
    });
}

document.addEventListener('DOMContentLoaded', initExpandingBlocks);

